module.exports = __webpack_public_path__ + "static/media/avatar-padrao.b3e8039b.jpg";